// @flow
import React from 'react';

import styles from './styles.module.scss';
import { Button } from '../index';

type Props = {
  type: string,
  user: string,
}
const ButtonPayPal = ({ type, user }: Props) => {
  const isDev = window.location.host.includes('develop') || window.location.host.includes('localhost');
  const actionURL = isDev ? 'https://www.sandbox.paypal.com/cgi-bin/webscr' : 'https://www.paypal.com/cgi-bin/webscr';
  const basicValue = isDev ? 'WLMNXMJQUAFMS' : 'KHV9UXQFSGLUS';
  const advancedValue = isDev ? 'Z8U85Z4J4ECEY' : 'GSXC55XQF7GV2';

  // plo5
  const plo4month = isDev ? 'ZPNX7Y7S5URP2' : '63YU6NA58EC5S';
  const plo5month = isDev ? '2JY33LQ6YNRHS' : 'AXTZ92G9QPR66';
  const plo45month = isDev ? 'BB32ZURXZS3J2' : 'XBPBL9LVFCG2G';
  const plo4year = isDev ? 'T4EPGQ5Y5HTJ8' : 'W8P3PZCV2V3HG';
  const plo5year = isDev ? '5QUCN5HJMTWJE' : 'VKF7UEUTHN9QU';
  const plo45year = isDev ? 'FHK453Z6QYBZS' : '8U43HFF3VAWVY';

  const plo4monthButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value={plo4month} />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const plo5monthButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value={plo5month} />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const plo45monthButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value={plo45month} />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const plo4yearButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value={plo4year} />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const plo5yearButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value={plo5year} />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const plo45yearButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value={plo45year} />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const basicButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value={basicValue} />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const advancedButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value={advancedValue} />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const advancedAnnualButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value="529LY3QVU4TNA" />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/ru_RU/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const basicAnnualButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value="39EUMUAKUWCF6" />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/ru_RU/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const advancedTrialButton = (
    <form className={styles.paypalobjects} action={actionURL} method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick" />
      <input type="hidden" name="hosted_button_id" value="CH4YS6ZXK3HTW" />
      <input
        className={styles.paypal}
        type="image"
        name="submit"
        alt=""
      />
      <Button
        className={styles.button}
        name="PROCEED TO CHECKOUT"
      />
      <input type="hidden" name="custom" value={user} />
      <img alt="" border="0" src="https://www.paypalobjects.com/ru_RU/i/scr/pixel.gif" width="1" height="1" />
    </form>
  );

  const button = () => {
    if (type === 'basic') return basicButton;
    if (type === 'advanced') return advancedButton;
    if (type === 'advancedAnnual') return advancedAnnualButton;
    if (type === 'basicAnnual') return basicAnnualButton;
    if (type === 'advancedTrial') return advancedTrialButton;
    if (type === 'plo4') return plo4monthButton;
    if (type === 'plo5') return plo5monthButton;
    if (type === 'plo4plo5') return plo45monthButton;
    if (type === 'plo4annual') return plo4yearButton;
    if (type === 'plo5annual') return plo5yearButton;
    if (type === 'plo4plo5annual') return plo45yearButton;
    return null;
  };
  return button();
};

export default ButtonPayPal;
